<template>
  <div>
    <div class='week-cell' :week="id" @click="expand">
      <div class='delete_icon' @click="deleteWeek">×</div>
      <div class='week-header'>
        <span class='week-name' style="padding-right: 1em; font-size: 2rem;">{{title}}</span>
        <EditModal v-if="isTeacher" :week="week"/>
        <span style='float: right;'>
          <span v-show="mode === 'simple'" class='week-time'>到期日: {{deadline}}</span>
          <span v-show="mode === 'advance'" class='week-time'>進階模式</span>
        </span>
      </div>
      <div class='week-content container-fluid'>
        <div class='row'>
          <div class='col-md-10'>
            <div class='week-description' style='font-size: 20pt; line-height: 1.5'>{{description}}</div>
          <div>
              <span class='week-subtitle' style="padding-right: 1em;">學習資源</span>
              <EditMaterialModal v-if="isTeacher" :id="id" :route="`courses/${this.courseId}/weeks/${this.id}/files`" :fileProps="files" :update="fetchFiles"/>
            </div>
            <div class='row week_material_container' style='min-height: 100px;'>
              <Material v-for="file in files" :key="file.id" :file="file"/>
            </div>
            <div class='week-subtitle'>任務數量: {{noOfActivities}}</div>
          </div>
        </div>
        <div style='text-align: right;'>
          <router-link class='details clickable' :to="{name: 'ClassActivities', query: {course: courseId, week: id}}">查看任務</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style type='text/css' scoped>
  .week-cell {
    -moz-box-shadow: 0 0 5px #8DD;
    -webkit-box-shadow: 0 0 5px #8DD;
    box-shadow: 0 0 5px #8DD;
    background-color: white;
    padding: 10px;
    border-radius: 11px;
    font-size: 15pt;
    color: var(--theme-light-color);
    cursor:pointer;
    margin: 15px;
  }
  .week-header:before, .week-header:after{
    display: table;
    content: ' ';
  }
  .week-header:after{
    clear: both
  }
  .week-name{
    font-weight: bold;
  }
  .week-time {
    font-size: 12pt;
    font-weight: 400;
  }
  .week-state{
    color: darkgray;
    font-size: smaller;
    font-weight: bolder;
    background-color: yellow;
  }
  .week-content{
    color: rgb(146,147,150);
      height: auto;
      display: none;
    /*
      -webkit-transform-origin: top;
      -ms-transform-origin: top;
      -o-transform-origin: top;
      transform-origin: top;
      -webkit-transform: scaleY(0);
      -ms-transform: scaleY(0);
      -o-transform: scaleY(0);
      transform: scaleY(0);
      -webkit-transition: -webkit-transform 0.5s;
      -ms-transition: -ms-transform 0.5s;
      -o-transition: -o-transform 0.5s;
      transition: transform 0.5s;
    */
  }
  .week-description {
    font-weight: 400;
    font-size: 14pt;
  }
  .week-subtitle{
    font-size: 14pt;
    font-weight: 550;
    color: var(--dark-gray);
  }
  .act_cell_num {
    border: 1px solid;
    padding: 15px;
    font-size: 25pt;
    font-weight: lighter;
    border-radius: 28%;
    width: 78px;
  }
  .week-title {
    padding: 10px 0;
  }
  .content_weekly_act {
    color: rgb(146,147,150);
    font-size: 12pt;
    font-weight: 500;
  }
  .details {
    display: inline-block;
    /*width: 30%;*/
    color: white !important;
    background-color: rgb(142, 202, 147);
    text-align: center;
    border-radius: 8px;
    padding: 10px;
  }
  .details:hover{
    text-decoration: unset;
  }
  .extend {
    padding:23px!important;
    margin-left:0px;
    width:98%
  }
  .delete_icon {
    float:right;
    top:-15px;
    right:-15px;
    background-color:rgb(237, 141, 132);
    color:#fff;
    padding:5px;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    width:30px;
    height:30px;
    text-align:center;
    cursor:pointer;
    display:none;
    font-size: 14pt;
  }
  .target .week-content{
  /*    -webkit-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      transform: scaleY(1);
  */
      display: initial;
  }
  .target{
      margin: 0;
      cursor: default !important;
  }
</style>
<script>
import $ from 'jquery'
import Material from '@/components/Weeks/Material'
import EditModal from '@/components/Weeks/EditModal'
import EditMaterialModal from '@/components/Weeks/EditMaterialModal'
export default {
  components: {
    Material,
    EditModal,
    EditMaterialModal
  },
  props: {
    week: Object
  },
  computed: {
    isTeacher: function () {
      return this.role === 'teacher'
    },
    isStudent: function () {
      return this.role === 'student'
    },
    role: function () {
      return this.$parent.role
    },
    courseId: function () {
      return parseInt(this.$route.query.course)
    },
    id: function () {
      return this.week.id
    },
    title: function () {
      return this.week.title
    },
    description: function () {
      return this.week.description
    },
    noOfActivities: function () {
      return this.week.noOfActivities
    },
    deadline: function () {
      return this.week.deadline
    },
    url: function () {
      return this.week.url
    },
    files: function () {
      return this.week.files
    },
    mode: function () {
      return this.week.mode
    }
  },
  methods: {
    deleteWeek: function (e) {
      e.stopPropagation()
      if (!confirm('是否確認刪除?')) {
        return
      }
      this.$store.dispatch('request', {
        method: 'delete',
        route: `courses/${this.courseId}/weeks/${this.id}`
      }).then(result => {
        this.$parent.removeWeek(this.id)
      })
    },
    expand: function (event) {
      var cell = $(event.target).closest('.week-cell')
      console.log(cell)
      if (!$(cell).hasClass('target')) {
        $('.target').removeClass('target')
        $(cell).addClass('target')
      }
    },
    updateWeek: function (weekData) {
      let index = this.$parent.weeks.findIndex(week => week.id === this.id)
      this.$parent.weeks[index].title = weekData.title
      this.$parent.weeks[index].description = weekData.description
    },
    fetchFiles: function () {
      this.$store.dispatch('request', {
        route: `courses/${this.courseId}/weeks/${this.id}/files`
      }).then(files => {
        console.log(files)
        this.week.files = files
      })
    }
  }
}
</script>
